export default __webpack_public_path__ + "static/media/6.017b5eb4.JPG";